import { Spacing32 } from 'autogen/design-tokens/tokens';
import type { ProductListPartialViewModel } from 'autogen/swagger/all';
import Layout from 'components/Layout';
import ProductListWithFilters from 'components/shared/productList/ProductListWithFilters';
import { useGetProductListPartial } from 'components/shared/productList/shared/hooks/useGetProductListPartialQuery';
import styled from 'styled-components';

const Container = styled.div`
    padding: ${Spacing32} 0;
`;

export default function ProductListPlaceholder({ model: initialModel }: { model: ProductListPartialViewModel }) {
    const { data: model } = useGetProductListPartial(initialModel);

    return (
        <Container>
            <Layout.Section>
                <ProductListWithFilters model={model} />
            </Layout.Section>
        </Container>
    );
}
